// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f5117e8e","504":"b6c43a2d","516":"712e8b71","675":"0ea6b72e"}[chunkId] + ".chunk.js";
};